'use client';
import styled from 'styled-components';

export const StyledForm = styled.form`
  background: ${props => props.theme.colors.background.base};
  flex: 1;
  display: grid;
  grid-gap: ${props => props.theme.spacing(4)};
  justify-items: center;
  padding: ${props => props.theme.spacing(0, 5)};
  overflow: auto;
  margin-bottom: 74px; /* 74px for navigation bar */
`;

export const CtaText = styled.p`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
`;

export const ModalContainer = styled.div`
  flex: 1;
  display: grid;
  text-align: center;
  grid-gap: ${props => props.theme.spacing(6)};
  justify-items: center;
  margin: ${props => props.theme.spacing(6, 4, 8)};
`;

export const ModalHeading = styled.h3`
  ${props => props.theme.typography.heading3};
  padding: ${props => props.theme.spacing(2)};
  margin: ${props => props.theme.spacing(2, 0)};
`;

export const ModalContent = styled.div`
  width: 75%;
  margin: auto;
`;

export const ModalContentTitle = styled.h5`
  ${props => props.theme.typography.subheading1};
`;

export const ModalContentBody = styled.p`
  ${props => props.theme.typography.body};
`;
